import _ from 'underscore'
import Types from '../actions/Types'

// #############################################################################
// Generator for LIST-type nodes
// #############################################################################

const listInitialState = {
  isFetching: false,
  data: null,
  error: null
}

const listNode = ({ baseType, suffixType }) => (state = listInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.LIST[suffixType].FETCH
    : baseType.LIST.FETCH
  const typeSuccess = suffixType
    ? baseType.LIST[suffixType].SUCCESS
    : baseType.LIST.SUCCESS
  const typeError = suffixType
    ? baseType.LIST[suffixType].ERROR
    : baseType.LIST.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        data: action.data,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        data: null,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.LIST
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for POST-type nodes with single phase
// #############################################################################

const postInitialState = {
  isFetching: false,
  data: null,
  id: null,
  error: null
}

const postNode = ({ baseType, suffixType }) => (state = postInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.POST[suffixType].FETCH
    : baseType.POST.FETCH
  const typeSuccess = suffixType
    ? baseType.POST[suffixType].SUCCESS
    : baseType.POST.SUCCESS
  const typeError = suffixType
    ? baseType.POST[suffixType].ERROR
    : baseType.POST.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        data: action.data,
        id: null,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        id: action.id,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        id: null,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.POST
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for POST-type nodes with 2 phases
// #############################################################################

const post2PhasesInitialState = {
  isFetching: false,
  phase: null,
  data: null,
  error: null
}

const post2PhaseNode = ({ baseType }) => (state = post2PhasesInitialState, action = null) => {
  switch (action.type) {
    case baseType.POST.P1.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        phase: 1,
        data: action.data,
        error: null
      })
    case baseType.POST.P1.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        phase: 1,
        data: action.data,
        error: null
      })
    case baseType.POST.P1.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        phase: 1,
        error: action.error
      })
    case baseType.POST.P2.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        phase: 2,
        data: action.data,
        error: null
      })
    case baseType.POST.P2.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        phase: 2,
        error: null
      })
    case baseType.POST.P2.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        phase: 2,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.POST.P1
        ||
        action.api === baseType.POST.P2
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for GET-type nodes
// #############################################################################

const getInitialState = {
  isFetching: false,
  id: null,
  data: null,
  error: null
}

const getNode = ({ baseType, suffixType }) => (state = getInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.GET[suffixType].FETCH
    : baseType.GET.FETCH
  const typeSuccess = suffixType
    ? baseType.GET[suffixType].SUCCESS
    : baseType.GET.SUCCESS
  const typeError = suffixType
    ? baseType.GET[suffixType].ERROR
    : baseType.GET.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        id: action.id,
        data: null,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        data: action.data,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        data: null,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.GET
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for PUT-type nodes
// #############################################################################

const putInitialState = {
  isFetching: false,
  id: null,
  data: null,
  error: null
}

const putNode = ({ baseType, suffixType }) => (state = putInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.PUT[suffixType].FETCH
    : baseType.PUT.FETCH
  const typeSuccess = suffixType
    ? baseType.PUT[suffixType].SUCCESS
    : baseType.PUT.SUCCESS
  const typeError = suffixType
    ? baseType.PUT[suffixType].ERROR
    : baseType.PUT.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        id: action.id,
        data: action.data,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.PUT
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for DELETE-type nodes
// #############################################################################

const deleteInitialState = {
  isFetching: false,
  id: null,
  error: null
}

const deleteNode = ({ baseType, suffixType }) => (state = deleteInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.DELETE[suffixType].FETCH
    : baseType.DELETE.FETCH
  const typeSuccess = suffixType
    ? baseType.DELETE[suffixType].SUCCESS
    : baseType.DELETE.SUCCESS
  const typeError = suffixType
    ? baseType.DELETE[suffixType].ERROR
    : baseType.DELETE.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        id: action.id,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.DELETE
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for REORDER-type nodes
// #############################################################################

const reorderInitialState = {
  isFetching: false,
  id: null,
  data: null,
  error: null
}

const reorderNode = ({ baseType, suffixType }) => (state = reorderInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.REORDER[suffixType].FETCH
    : baseType.REORDER.FETCH
  const typeSuccess = suffixType
    ? baseType.REORDER[suffixType].SUCCESS
    : baseType.REORDER.SUCCESS
  const typeError = suffixType
    ? baseType.REORDER[suffixType].ERROR
    : baseType.REORDER.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        id: action.id,
        data: action.data,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.REORDER
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for EXECUTE-type nodes
// #############################################################################

const executeInitialState = {
  isFetching: false,
  id: null,
  data: null,
  error: null
}

const executeNode = ({ baseType, suffixType }) => (state = executeInitialState, action = null) => {
  const typeFetch = suffixType
    ? baseType.EXECUTE[suffixType].FETCH
    : baseType.EXECUTE.FETCH
  const typeSuccess = suffixType
    ? baseType.EXECUTE[suffixType].SUCCESS
    : baseType.EXECUTE.SUCCESS
  const typeError = suffixType
    ? baseType.EXECUTE[suffixType].ERROR
    : baseType.EXECUTE.ERROR
  switch (action.type) {
    case typeFetch:
      return _.extend({}, state, {
        isFetching: true,
        id: action.id,
        data: action.data,
        error: null
      })
    case typeSuccess:
      return _.extend({}, state, {
        isFetching: false,
        error: null
      })
    case typeError:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
        ||
        action.api === baseType.EXECUTE
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// Generator for PRINT-type nodes
// #############################################################################

const printInitialState = {
  isFetching: false,
  error: null
}

const printNode = ({ baseType }) => (state = printInitialState, action = null) => {
  switch (action.type) {
    case baseType.FETCH:
      return _.extend({}, state, {
        isFetching: true,
        error: null
      })
    case baseType.SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        error: null
      })
    case baseType.ERROR:
      return _.extend({}, state, {
        isFetching: false,
        error: action.error
      })
    case Types.APP.CLEARERROR:
      return (
        _.isUndefined(action.api)
        ||
        action.api === baseType
      )
        ? _.extend({}, state, {
            error: null
          })
        : state
    default:
      return state
  }
}

// #############################################################################
// ES6 Module export
// #############################################################################

const NODETYPE = {
  LIST: 'LIST',
  POST: 'POST',
  POST2PHASES: 'POST2PHASES',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
  REORDER: 'REORDER',
  EXECUTE: 'EXECUTE',
  PRINT: 'PRINT'
}

export default {
  node: ({ baseType, suffixType, nodeType }) => {
    let node
    switch (nodeType) {
      case NODETYPE.LIST:
        node = listNode
        break
      case NODETYPE.POST:
        node = postNode
        break
      case NODETYPE.POST2PHASES:
        node = post2PhaseNode
        break
      case NODETYPE.GET:
        node = getNode
        break
      case NODETYPE.PUT:
        node = putNode
        break
      case NODETYPE.DELETE:
        node = deleteNode
        break
      case NODETYPE.REORDER:
        node = reorderNode
        break
      case NODETYPE.EXECUTE:
        node = executeNode
        break
      case NODETYPE.PRINT:
        node = printNode
        break
      default:
        node = getNode
        break
    }
    return node({ baseType, suffixType })
  },
  NODETYPE
}



// WEBPACK FOOTER //
// ./src/reducers/Generator.js